var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("h3", [_vm._v("Tasks")]),
      _c(
        "b-row",
        { staticClass: "align-items-center mb-4" },
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end align-items-center" },
              [
                !_vm.$route.fullPath.includes("view")
                  ? _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.modal-add-task",
                            modifiers: { "modal-add-task": true },
                          },
                        ],
                        attrs: { variant: "primary" },
                      },
                      [_vm._v(" Add Task ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm.tasks.length === 0
        ? _c(
            "div",
            [
              _c(
                "b-row",
                { staticClass: "justify-content-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c(
                        "b-card",
                        [
                          _c("b-card-body", { staticClass: "text-center" }, [
                            _c("h2", [_vm._v("No tasks available")]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : !_vm.displayKanban
        ? _c(
            "div",
            [
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "text-center my-4" },
                    [_c("b-spinner", { attrs: { label: "Loading tasks..." } })],
                    1
                  )
                : _vm._e(),
              _c(
                "b-row",
                { staticClass: "mb-4 align-items-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          placeholder: "Search tasks...",
                          debounce: "300",
                        },
                        model: {
                          value: _vm.searchQuery,
                          callback: function ($$v) {
                            _vm.searchQuery = $$v
                          },
                          expression: "searchQuery",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "text-right", attrs: { md: "8" } },
                    [
                      _c("span", { staticClass: "text-muted" }, [
                        _vm._v(
                          " Showing " +
                            _vm._s(_vm.filteredTasks.length) +
                            " of " +
                            _vm._s(_vm.tasks.length) +
                            " tasks "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              !_vm.loading
                ? _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      responsive: "",
                      items: _vm.paginatedTasks,
                      fields: _vm.fields,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(actions)",
                          fn: function (data) {
                            return [
                              !_vm.$route.fullPath.includes("view")
                                ? _c(
                                    "b-dropdown",
                                    {
                                      attrs: {
                                        id: "actions-dropdown",
                                        variant: "link",
                                        size: "sm",
                                        text: "Actions",
                                        right: "",
                                        "no-caret": "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "button-content",
                                            fn: function () {
                                              return [
                                                _c("feather-icon", {
                                                  staticClass:
                                                    "align-middle text-body",
                                                  attrs: {
                                                    icon: "MoreVerticalIcon",
                                                    size: "16",
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c(
                                        "b-dropdown-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.editTask(data.item)
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-50",
                                            attrs: {
                                              icon: "EditIcon",
                                              size: "16",
                                            },
                                          }),
                                          _vm._v(" Edit "),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-dropdown-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteTask(
                                                data.item.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-50",
                                            attrs: {
                                              icon: "TrashIcon",
                                              size: "16",
                                            },
                                          }),
                                          _vm._v(" Delete "),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1723641116
                    ),
                  })
                : _vm._e(),
              !_vm.loading
                ? _c("b-pagination", {
                    staticClass: "my-2",
                    attrs: {
                      "per-page": _vm.perPage,
                      "total-rows": _vm.tasks.length,
                      align: "center",
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "kanban" },
            [_c("kanban-task", { attrs: { tasks: _vm.tasks } })],
            1
          ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-add-task",
            title: _vm.isEditing ? "Edit Task" : "Add Task",
            "hide-footer": "",
            size: "lg",
            centered: "",
          },
          on: { hidden: _vm.resetForm },
        },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.validateAndSubmit($event)
                },
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: { label: "Title", "label-for": "task_title" },
                        },
                        [
                          _c("b-form-input", {
                            class: { "is-invalid": _vm.titleState === false },
                            attrs: { id: "task_title", placeholder: "Title" },
                            on: { blur: _vm.validateTitle },
                            model: {
                              value: _vm.newTask.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.newTask, "title", $$v)
                              },
                              expression: "newTask.title",
                            },
                          }),
                          _vm.titleState === false
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v("Title is required"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Description",
                            "label-for": "task_description",
                          },
                        },
                        [
                          _c("b-form-input", {
                            class: {
                              "is-invalid": _vm.descriptionState === false,
                            },
                            attrs: {
                              id: "task_description",
                              placeholder: "Description",
                            },
                            on: { blur: _vm.validateDescription },
                            model: {
                              value: _vm.newTask.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.newTask, "description", $$v)
                              },
                              expression: "newTask.description",
                            },
                          }),
                          _vm.descriptionState === false
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v("Description is required "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Start Date",
                            "label-for": "start_date",
                          },
                        },
                        [
                          _c("b-form-datepicker", {
                            class: {
                              "is-invalid": _vm.startDateState === false,
                            },
                            attrs: { id: "start_date", min: _vm.currentDate },
                            on: { input: _vm.validateStartDate },
                            model: {
                              value: _vm.newTask.startDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.newTask, "startDate", $$v)
                              },
                              expression: "newTask.startDate",
                            },
                          }),
                          _vm.startDateState === false
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v("Start Date is required"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: { label: "End Date", "label-for": "end_date" },
                        },
                        [
                          _c("b-form-datepicker", {
                            class: { "is-invalid": _vm.endDateState === false },
                            attrs: {
                              id: "end_date",
                              min: _vm.newTask.startDate || _vm.currentDate,
                            },
                            on: { input: _vm.validateEndDate },
                            model: {
                              value: _vm.newTask.endDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.newTask, "endDate", $$v)
                              },
                              expression: "newTask.endDate",
                            },
                          }),
                          _vm.endDateState === false
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v("End Date must be after Start Date"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Assignee(s)",
                            "label-for": "assignee",
                          },
                        },
                        [
                          _c("b-form-select", {
                            class: {
                              "is-invalid": _vm.assigneeState === false,
                            },
                            attrs: { options: _vm.assignee_options },
                            on: { change: _vm.validateAssignee },
                            model: {
                              value: _vm.newTask.assigneeId,
                              callback: function ($$v) {
                                _vm.$set(_vm.newTask, "assigneeId", $$v)
                              },
                              expression: "newTask.assigneeId",
                            },
                          }),
                          _vm.assigneeState === false
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v("Please select an assignee"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Status", "label-for": "status" } },
                        [
                          _c("b-form-select", {
                            class: { "is-invalid": _vm.statusState === false },
                            attrs: { options: _vm.statusOptions },
                            on: { change: _vm.validateStatus },
                            model: {
                              value: _vm.newTask.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.newTask, "status", $$v)
                              },
                              expression: "newTask.status",
                            },
                          }),
                          _vm.statusState === false
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v("Please select a status"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        { attrs: { type: "submit", variant: "primary" } },
                        [
                          _vm._v(
                            _vm._s(_vm.isEditing ? "Update Task" : "Add Task")
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }